// extracted by mini-css-extract-plugin
export default {"option":"Footer_option__mVz6R","sectionHeader":"Footer_sectionHeader__btduV","socialIcon":"Footer_socialIcon__uig3t"};